export default __webpack_public_path__ + "static/media/background_planet-01_top.277fea04.jpg";